/**
 * Downloads media originals as one zip. A real form POST (not fetch) lets the
 * browser stream the archive straight to disk, however large it is.
 * `items` are [{ id, path }] where `path` is the folder inside the zip.
 */
export function downloadZip(items: { id: string; path?: string }[], name = 'media') {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/api/media/zip';
  form.style.display = 'none';
  for (const [k, v] of [
    ['items', JSON.stringify(items)],
    ['name', name],
  ]) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = v;
    form.append(input);
  }
  document.body.append(form);
  form.submit();
  form.remove();
}
